var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.eventBaseGroups,"box":"","value":_vm.value,"item-text":"Name","item-value":"id","multiple":"","label":_vm.label[_vm.$i18n.locale]},on:{"change":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }